<template>
    <div class="voting-frame">
        <form @submit.prevent="vote" class="voting">
            <div v-if="isAuthorized" class="voting__user">
                <span>Здравствуйте, {{userName}}</span>
                <button type="button" title="Выйти" @click="logout">
                    <i class="fapp fa-log-out"></i>
                </button>
            </div>
            <h2 class="voting__title">{{ poll.name }}</h2>
            <p class="voting__lid">
                <template v-if="!isCompleted">
                    Результаты доступны для просмотра только после того, как вы авторизуетесь и проголосуете
                </template>
                <template v-else>
                    Голосование завершено
                </template>
            </p>
            <vue-perfect-scrollbar class="voting__list">
                <div
                        v-for="object in objects"
                        :key="object.id"
                        :class="['voting__item', {'voting__item--selected': selectedObjectsIds.map((el) => +el).indexOf(+object.id) !== -1}] ">
                    <label class="switch">
                        <input
                                type="checkbox"
                                name="objects"
                                :value="object.id"
                                v-model="selectedObjectsIds"
                                :disabled="votedObjectsIds.indexOf(+object.id) !== -1 || isCompleted"
                        >
                        <div class="switch__check">
                            <i class="fapp fa-check"></i>
                        </div>
                        <div class="switch__text">
                            <div class="voting__item-head">
                                <p class="voting__item-name">
                                    {{ object.name }}
                                    <span v-if="haveVoted" class="voting__item-name-count" title="Количество голосов">{{ object.votes }}</span>
                                </p>
                                <p class="voting__item-count">
                                    <template v-if="haveVoted">
                                        {{ object.percentage }}%
                                    </template>
                                </p>
                            </div>
                            <div class="voting__item-progress">
                                <div class="voting__item-progress-dynamic" :style="{width: haveVoted ? object.percentage + '%' : 0}"></div>
                                <div class="voting__item-progress-static"></div>
                            </div>
                        </div>
                    </label>
                </div>
            </vue-perfect-scrollbar>
            <div class="voting__footer">
                <button :disabled="newSelectedObjects.length === 0" class="generic-button generic-button--blue">Голосовать</button>
                <a href="/" class="generic-button" target="_blank">Подробная информация</a>
            </div>
            <p class="voting__people">Проголосовало человек: {{ voted }}</p>
        </form>
        <transition name="fade">
            <div v-if="showAuthButtons" class="wrap-modal" style="display: block; top: 0; left: 0">
                <span class="wrap-modal__overlay"></span>
                <form method="POST" class="modal-form">
                    <div class="modal-form__header">
                        <p class="modal-form__title">Авторизация</p>
                        <button @click="showAuthButtons = false" type="button" class="modal-form__close js-close-authorization"><i class="fapp fa-cross"></i></button>
                    </div>
                    <div class="modal-form__body">
                        <p>Для того, чтобы оставить свой голос за один из проектов, вы должны пройти авторизацию, используя аккаунт одной из предложенных социальных сетей.</p>
                        <p>Авторизуясь на сайте, вы подтверждаете, что ознакомились с <a target="_blank" href="http://xn--80aaac0ct.xn--p1ai/main/formirovanie-komfortnoj-gorodskoj-sredy.html">правилами программы</a> и <a target="_blank" href="/privacy-policy">политикой конфиденциальности</a>, и согласны с прочитанным. </p>
                        <div class="social-box">
                            <button @click="authorization('vk')" type="button" class="social-box__item social-box__item--vk"><i class="fapp fa-vk"></i></button>
                            <button @click="authorization('ok')" type="button" class="social-box__item"><i class="fapp fa-ok"></i></button>
                            <button @click="authorization('fb')" type="button" class="social-box__item"><i class="fapp fa-fb"></i></button>
                            <button @click="authorization('in')" type="button" class="social-box__item"><i class="fapp fa-instagram"></i></button>
                        </div>
                    </div>
                </form>
            </div>
        </transition>
        <div v-if="isLoading" class="voting__loading loading">
        </div>
        <transition name="fade">
            <div v-if="errorMessage.length > 0" class="voting__error">
                {{ errorMessage }}
                <button @click="errorMessage = ''">
                    <i class="fapp fa-cross"></i>
                </button>
            </div>
        </transition>
    </div>
</template>

<script>
    require('@fortawesome/fontawesome-free/css/fontawesome.min.css');
    require('@fortawesome/fontawesome-free/js/fontawesome.min');
    require('../../libs/fontawesome/fapp');
    const VuePerfectScrollbar = require('vue-perfect-scrollbar').default;

    window.axios = require('axios');
    window.qs = require('querystring');

    export default {
        data: function() {
            return {
                isLoading: false,
                haveVoted: window.serverData.haveVoted,
                isAuthorized: window.serverData.isAuthorized,
                userName: window.serverData.userName,
                showAuthButtons: false,
                objects: window.serverData.objects,
                poll: window.serverData.poll,
                selectedObjectsIds: window.serverData.votedObjects,
                votedObjectsIds: window.serverData.votedObjects.map(el => +el),
                voted: window.serverData.voted || 0,
                errorMessage: '',
                errorTimer: 0,
                isCompleted: window.serverData.isCompleted,
            };
        },
        computed: {
            newSelectedObjects() {
                let votedObjects = this.votedObjectsIds.map(el => +el);
                return this.selectedObjectsIds.filter(el => votedObjects.indexOf(+el) === -1);
            }
        },
        methods: {
            vote() {
                if (!this.selectedObjectsIds.length) {
                    return;
                }
                if (!this.isAuthorized) {
                    this.showAuthButtons = true;
                } else {
                    let data = {
                        action: 'vote',
                        data: JSON.stringify({
                            poll: this.poll.id,
                            objects: this.newSelectedObjects,
                        }),
                    };
                    this.isLoading = true;
                    this.callHandler('vote', data).then((res) => {
                        if (res.status) {
                            this.voted = res.voted;
                            this.objects.forEach((obj) => {
                                obj.percentage = res.results[obj.id].percentage;
                                obj.votes = res.results[obj.id].votes;
                            });
                            this.haveVoted = true;
                            this.votedObjectsIds = res.votedObjects;
                            this.selectedObjectsIds = res.votedObjects;
                            if (res.ignored) {
                                this.showError('Вы уже голосовали за один из выбранных объектов, этот голос не был учтен повторно');
                            }
                        } else {
                            this.showError(res.message || 'что-то пошло не так...');
                        }
                        this.isLoading = false;
                    });
                }
            },
            logout() {
                this.isLoading = true;
                this.callHandler('public-auth', {action: 'logout'}).then((r) => {
                    this.isLoading = false;
                    if (r.status) {
                        this.isAuthorized = false;
                        this.userName = false;
                        this.haveVoted = false;
                        this.selectedObjectsIds = [];
                        this.votedObjectsIds = [];
                    } else {
                        this.showError(r.message || 'что-то пошло не так...');
                    }
                });
            },
            callHandler(name, data) {
                data = qs.stringify(data);
                return axios.post('/handlers/' + name, data)
                    .then(response => {
                        return response.data;
                    })
                    .catch(error => {
                        let message = '[HTTP error] ';

                        if (error.response) {
                            message += `Сервер вернул статус ${error.response.status}`;
                        } else if (error.request) {
                            message += 'Нет ответа от сервера';
                        } else {
                            message += error.message;
                        }

                        return {
                            status: false,
                            message,
                        };
                    });
            },
            authorization(provider) {
                window.authSuccess = (user) => {
                    this.userName = user.name;
                    this.isAuthorized = true;
                    this.showAuthButtons = false;
                    this.vote();
                };
                window.open('/auth?provider=' + provider, 'publicAuth', 'titlebar,close,width=1000,height=600');
            },
            showError(text) {
                this.errorMessage = text;
                console.log(this.errorTimer);
                if (this.errorTimer) {
                    clearTimeout(this.errorTimer);
                }
                this.errorTimer = setTimeout(() => {
                    this.errorMessage = '';
                }, 3000);
            },
        },
        components: {
            VuePerfectScrollbar,
        },
    }
</script>

<style>
    .voting-frame {
        background: black;
    }
</style>